module.exports = __webpack_public_path__ + "d15d9a602a34a9eddf46071d79b687a7.png";